"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.5 21c-1.674 0-2.421-.928-3.142-1.825l-.027-.033a9.656 9.656 0 0 0-.685-.789C16.786 17.493 14.728 17 12 17c-2.728 0-4.786.493-5.646 1.354-.25.257-.485.529-.704.812l-.008.01C4.921 20.072 4.174 21 2.5 21 0 21 0 17.87 0 16 0 9.933 3.436 4 6 4c1.192 0 1.888.47 2.56.923l.002.001C9.345 5.453 10.155 6 12 6c1.845 0 2.655-.547 3.438-1.076h.001C16.112 4.468 16.808 4 18 4c2.564 0 6 5.933 6 12 0 1.87 0 5-2.5 5ZM12 16c1.758 0 4.92.214 6.354 1.646.291.291.541.601.783.902.678.843 1.168 1.452 2.363 1.452 1.255 0 1.5-1.467 1.5-4 0-6.02-3.311-11-5-11-.887 0-1.378.332-2.001.751l-.001.001C15.175 6.308 14.15 7 12 7c-2.15 0-3.175-.692-3.998-1.248C7.379 5.331 6.887 5 6 5 4.311 5 1 9.98 1 16c0 2.533.245 4 1.5 4 1.195 0 1.685-.609 2.363-1.452.242-.301.492-.611.783-.902C7.08 16.214 10.242 16 12 16Zm-3.5-.995a.5.5 0 0 1-.5-.495L7.995 14h-.503a.5.5 0 0 1 0-1h.503c.003-.156.008-.287.015-.397.04-.557.151-.57.438-.6a.492.492 0 0 1 .543.405.465.465 0 0 1 .003.178c-.002.138-.003.276-.002.414h.5a.5.5 0 0 1 0 1h-.495l.004.5a.502.502 0 0 1-.496.505H8.5Zm7.008.003c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5Zm0-2a.502.502 0 1 0 .001 1.003.502.502 0 0 0-.001-1.003ZM3.992 9c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2Zm1 0a1.001 1.001 0 0 1 2 0 1.001 1.001 0 0 1-2 0Zm11.5 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.516-2.492a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM18.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.492-2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    clipRule: "evenodd"
  })]
});